import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { ArrowRight } from 'lucide-react';
import AdvertiseWithUs from './AdvertiseWithUs';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const SponsorshipBanner = ({ placement = 'home_middle', className = '' }) => {
  const [ads, setAds] = useState([]);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const { data } = await axios.get(`${API}/sponsorship?placement=${placement}`);
        if (!cancelled) setAds(data.ads || []);
      } catch (e) {
        console.error('[Sponsorship] fetch failed:', e);
      }
    })();
    return () => { cancelled = true; };
  }, [placement]);

  if (!ads || ads.length === 0) return null;
  const ad = ads[0];

  return (
    <div className={`px-4 md:px-14 mt-8 ${className}`}>
      <div className="flex items-center justify-between mb-2 gap-3">
        <span className="text-[10px] uppercase tracking-widest text-white/40">Sponsored</span>
        <AdvertiseWithUs variant="pill" />
      </div>
      <a
        href={ad.link_url || '#'}
        target="_blank"
        rel="noreferrer"
        className="group relative block rounded-lg overflow-hidden border border-white/10 shadow-lg hover:border-white/25 transition-colors"
      >
        <div className="relative h-40 md:h-56 w-full">
          <img src={ad.image_url} alt={ad.title} className="absolute inset-0 w-full h-full object-cover transition-transform duration-500 group-hover:scale-105" loading="lazy" />
          <div className="absolute inset-0 bg-gradient-to-r from-black/85 via-black/50 to-black/10" />
          <div className="relative z-10 h-full flex flex-col justify-center px-5 md:px-10 max-w-2xl">
            <div className="text-[10px] uppercase tracking-widest text-[#e11d48] font-semibold">Sponsored feature</div>
            <h3 className="text-white text-xl md:text-3xl font-extrabold mt-1">{ad.title}</h3>
            {ad.subtitle && <p className="text-white/80 text-sm md:text-base mt-2 max-w-lg">{ad.subtitle}</p>}
            <div className="mt-4">
              <span className="inline-flex items-center gap-1.5 bg-white text-black font-semibold text-sm px-4 py-2 rounded hover:bg-white/85 transition-colors">
                {ad.cta || 'Learn more'} <ArrowRight className="w-4 h-4" />
              </span>
            </div>
          </div>
        </div>
      </a>
    </div>
  );
};

export default SponsorshipBanner;
